<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>Graph Labeling Study</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="8">
            <v-card class="pa-6">
              <v-card-title class="text-h5">Before we begin</v-card-title>
              <v-card-text>
                <p class="mb-4">Please answer a few brief questions about yourself.</p>

                <v-select
                  v-model="education_level"
                  :items="educationOptions"
                  label="Highest level of education completed"
                  outlined
                  class="mb-4"
                ></v-select>

                <v-select
                  v-model="graph_familiarity"
                  :items="familiarityOptions"
                  label="How familiar are you with graph/network diagrams?"
                  outlined
                  class="mb-4"
                ></v-select>

                <!-- Placeholder for additional pre-study fields -->
                <v-alert type="info" outlined dense class="mb-4">
                  Post-study questions will be added in a later update.
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" large :disabled="!canContinue" :loading="loading" @click="submit">
                  Continue to Training
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import config from '@/config';

export default {
  name: 'Demographics',
  title: 'Demographics',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      education_level: null,
      graph_familiarity: null,
      loading: false,
      educationOptions: [
        'Less than high school',
        'High school diploma / GED',
        'Some college (no degree)',
        'Associate degree',
        "Bachelor's degree",
        "Master's degree",
        'Doctorate / Professional degree',
        'Prefer not to say',
      ],
      familiarityOptions: [
        'Never seen one',
        'Seen but never worked with',
        'Basic familiarity',
        'Moderate familiarity (used in coursework or work)',
        'Expert (regularly use graph/network visualizations)',
      ],
    };
  },
  computed: {
    canContinue() {
      return this.education_level && this.graph_familiarity;
    },
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const resp = await fetch(
          `${config.API_BASE_URL}/prolific/session/${this.sessionId}/demographics/`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              education_level: this.education_level,
              graph_familiarity: this.graph_familiarity,
            }),
          }
        );
        if (resp.ok) {
          this.$router.push(`/prolific/study/${this.sessionId}/training`);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
